import { defineStore } from 'pinia';
import { API } from '@/services';
import { GET_WORKSPACE_TEAM_MEMBERS_QUERY, GET_WORKSPACES_QUERY } from '@/services/workspace/queries/workspace/index.js';
import { UPDATE_USER_PREFERENCES_MUTATION } from '@/services/user/mutations/user/index.js';

export const useWorkspaceStore = defineStore({
  id: 'workspace',
  state: () => ({
    isLoading: false,
    isSwitchingWorkspace: false,
    workspaces: [],
    activeWorkspace: null,
    notificationForm: {
      isLoading: false,
      switchName: null
    }
  }),
  actions: {
    async getWorkspaces(payload) {
      try {
        this.isLoading = true;
        this.workspaces = [];
        const res = await API.sendQuery('/graphql/workspace', GET_WORKSPACES_QUERY, payload);
        if (res.data.errors) {
          // console.log('Trying to retrieve workspaces:', res.data.errors);
        }
        res.data.data.workspaces ? this.setWorkspaces(res.data.data.workspaces) : (this.workspaces = []);
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },

    parsePreferences(preferences)
    {
      if (!Array.isArray(preferences)) return null;

      for (const item of preferences) {
        if (item.key === 'active_workspace') {
          try {
            return JSON.parse(item.value);
          } catch (error) {
            console.error('Error parsing active_workspace value:', error);
            return null;
          }
        }
      }
      return null; // Return null if active_workspace is not found
    },

    setWorkspaces(workspaces) {
      this.workspaces = workspaces
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        })
        .sort((a, b) => {
          return a.archived - b.archived;
        });
    },

    async setActiveWorkspace(workspace) {
      this.activeWorkspace = workspace;
      await API.sendQuery('/graphql/user', UPDATE_USER_PREFERENCES_MUTATION, {
        preferences: [
          {
            key: 'active_workspace',
            value: workspace ? JSON.stringify(workspace) : ''
          }
        ]
      });
    },

    async getTeamMembers(workspaceId, role) {
      const payload = { workspace_id: parseInt(workspaceId), role: role };
      return await API.sendQuery('/graphql/workspace', GET_WORKSPACE_TEAM_MEMBERS_QUERY, payload);
    }
  }
});
